import { render } from "./FinancialTips.vue?vue&type=template&id=42cb9158&scoped=true&ts=true"
import script from "./FinancialTips.vue?vue&type=script&lang=ts"
export * from "./FinancialTips.vue?vue&type=script&lang=ts"

import "./FinancialTips.vue?vue&type=style&index=0&id=42cb9158&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cb9158"]])

export default __exports__